export const INSPECTION_MODE = {
  normal: "normal",
  inspection: "inspection",
};

export function currentYear() {
  return new Date().getFullYear();
}

export function formatNumber(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n.toLocaleString("ru-RU") : "0";
}

export function formatPercent(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? `${n.toFixed(n % 1 === 0 ? 0 : 1)}%` : "0%";
}

export function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export function fullName(user) {
  if (!user) return "";
  return [user.lastname, user.name, user.fathername].filter(Boolean).join(" ").trim();
}

export const CHECK_ITEM_LABELS_UZ_CYR = {
  foundation_cond: "Таянч фундаменти ҳолати",
  foundation_nuts_tight: "Таянч фундаментидаги гайкалар тўлиқ қотирилганлиги",
  base_washout: "Таянч остини сув ювиш, очилиб қолиш ҳолати",
  soil_protect_obval: "Таянч ости, фундаментлари тупроқ билан ҳимояланганлиги (обваловка)",
  earthing_kz_cond: "Таянч ерлагичлари ҳолати (КЗ)",
  concrete_base_protect: "Ж/Б таянч ҳолати, остки қисми тупроқ билан ҳимояланганлиги",
  pole_tilt: "Таянчнинг қийшайган, оғишма ҳолати",
  dispatcher_marks: "Диспетчерлик ёзувлари ва номланиши мавжудлиги",
  angle_iron_cond: "Таянч уголниклари ҳолати",
  nuts_welded: "Таянч гайкаларининг пайвандланганлиги",
  bolts_thread_punched: "Таянчлардаги болтларнинг резбалари керно қилинганлиги",
  angle_iron_welded: "Таянчлардаги уголникларнинг бир-бирига пайвандланганлиги",
  factory_welds_cond: "Ишлаб чиқарувчи томонидан пайвандланган чоклар ҳолати",
  leg_fit_to_found: "Металл таянч оёғининг фундамент билан оралиғи жипслиги",
  guy_anbolts_cond: "Таянч тортқичлари ва АН болтлари ҳолати",
  cotter_pins: "Шплинтлар мавжудлиги",
  insulators_cond: "Изоляторлар ҳолати, тўғрилиги ва оғишма ҳолати",
  conductors_cond: "Симлар ҳолати",
  shunt_cond: "Шунт ҳолати",
  sas_present: "Шлейфларда ҳамда таянчлар оралиғида САСлар мавжудлиги",
  thermovision_temp: "Болтли ва пресс бирикмаларда тепловизор назоратида ҳарорат кўрсаткичи",
  temp_sas_c: "САС (C°)",
  temp_nas_c: "НАС (C°)",
  pa_clamps_cond: "Болтли бирикмалар (PA қисқичлар) ҳолати",
  thermoweld_present: "Термопайка мавжудлиги",
  damper_gvn_cond: "Симдаги сўндиргич ҳолати (ГВН)",
  spacers_cond: "Распоркалар ҳолати",
  gzt_present: "Чақмоққа қарши трос (ГЗТ) мавжудлиги",
  gzt_cond: "Чақмоққа қарши трос ҳолати",
  spark_gap_cond: "Учқун оралиғи ҳолати (искровой промежуток)",
  gzt_earthing_cond: "Чақмоққа қарши трос ерланганлик ҳолати",
  vols_cond: "Оптик толали алоқа тармоғи (ВОЛС) ҳолати",
  corridor_trees: "Муҳофаза ҳудудида дарахтлар мавжудлиги",
  corridor_reeds: "Муҳофаза ҳудудида қамиш мавжудлиги",
  corridor_wheat: "Муҳофаза ҳудудида буғдой майдонлари мавжудлиги",
  corridor_buildings: "Муҳофаза ҳудудида бино ва иншоотлар мавжудлиги",
  clearance_ok: "Сим билан ер, дарахт, бино орасидаги масофа ҳолати",
  bird_guard_qqt: "ҚҚТ (қушларга қарши тўсиқ) мавжудлиги",
  cross_road: "Йўл билан кесишмалар мавжудлиги",
  cross_powerline: "Электр тармоғи билан кесишмалар мавжудлиги",
  cross_river: "Дарё ва ҳоказо билан кесишмалар мавжудлиги",
  winter_ice: "Қиш мавсумида сим, тросдаги музламалар мавжудлиги",
};

export function hasDisplayValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed !== "" && trimmed !== "-";
  }
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return true;
}

export function formatVerificationStatus(value) {
  const normalized = String(value || "").trim().toLowerCase();
  switch (normalized) {
    case "verified":
      return "Тасдиқланган";
    case "failed":
      return "Тасдиқланмаган";
    case "pending":
      return "Кутилмоқда";
    case "skipped_offline":
      return "Офлайн сақланган";
    case "skipped":
      return "Ўтказиб юборилган";
    default:
      return "";
  }
}

export function formatMeters(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  const rounded = Math.round(n * 10) / 10;
  return `${Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1)} м`;
}

export function formatCheckValue(value) {
  if (!hasDisplayValue(value)) return "";
  if (typeof value === "boolean") return value ? "Ҳа" : "Йўқ";
  if (Array.isArray(value)) return value.map(formatCheckValue).filter(Boolean).join(", ");
  if (typeof value === "object") return "";

  const text = String(value).trim();
  switch (text.toLowerCase()) {
    case "yes":
      return "Ҳа";
    case "no":
      return "Йўқ";
    case "na":
      return "Тегишли эмас";
    case "true":
      return "Ҳа";
    case "false":
      return "Йўқ";
    default:
      return text;
  }
}

export function negativeReasonEntries(value) {
  const reasons = negativeReasonsObject(value);
  return Object.entries(reasons)
    .map(([key, reasonValue]) => ({
      key,
      label: CHECK_ITEM_LABELS_UZ_CYR[key] || "",
      value: formatCheckValue(reasonValue),
    }))
    .filter((item) => item.label && item.value);
}

export function statusLabel(status) {
  switch (status) {
    case "emergency":
    case "has_emergency":
      return "Авария ҳолатида";
    case "problem":
    case "has_problem":
      return "Камчиликлар билан";
    case "inspected_ok":
    case "completed":
      return "Кўрикдан ўтган";
    case "partial":
      return "Қисман";
    case "not_started":
    case "uninspected":
      return "Кўрикдан ўтмаган";
    case "no_coordinates":
      return "Координатасиз";
    default:
      return "-";
  }
}

export function statusClass(status) {
  switch (status) {
    case "emergency":
    case "has_emergency":
      return "is-emergency";
    case "problem":
    case "has_problem":
      return "is-problem";
    case "inspected_ok":
    case "completed":
      return "is-ok";
    case "partial":
      return "is-partial";
    case "no_coordinates":
      return "is-muted";
    default:
      return "is-uninspected";
  }
}

export function negativeReasonsObject(value) {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}
